"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletAdapterManager = void 0;
exports.createWalletConnectionManager = createWalletConnectionManager;
var index_1 = require("../types/index");
var storage_1 = require("../utils/storage");
var adapters_1 = require("./adapters");
var wallet_standard_base_1 = require("@hermis/wallet-standard-base");
var solana_headless_core_1 = require("@hermis/solana-headless-core");
var errors_1 = require("@hermis/errors");
/**
 * Create a simple wallet connection manager with built-in adapter management
 *
 * The `network` parameter is required — wallet adapters now need an explicit
 * cluster so their chain hints can't be spoofed by URL substring inference.
 *
 * @param adapters Array of adapters to manage
 * @param network Active Solana network for the cluster hint
 * @param localStorageKey Key to store the selected wallet name
 * @param endpoint Optional RPC endpoint for wallet detection
 * @returns Wallet connection manager object
 */
function createWalletConnectionManager(adapters, network, localStorageKey, endpoint) {
    var _this = this;
    if (localStorageKey === void 0) { localStorageKey = 'walletName'; }
    // Internal state for adapters
    var currentAdapters = [];
    var adaptersChangeCallbacks = new Set();
    var storageUtil = (0, storage_1.createLocalStorageUtility)(localStorageKey, null);
    var currentAdapter = null;
    // Helper function to notify adapter change callbacks
    function notifyAdaptersChange() {
        adaptersChangeCallbacks.forEach(function (callback) {
            try {
                callback(__spreadArray([], currentAdapters, true));
            }
            catch (error) {
                console.error('Error in adapters change callback:', error);
            }
        });
    }
    // Initialize wallet detection and get initial adapters
    (function () { return __awaiter(_this, void 0, void 0, function () {
        var detectedAdapters, storedWalletName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, wallet_standard_base_1.getStandardWalletAdapters)(adapters, endpoint, network)];
                case 1:
                    detectedAdapters = _a.sent();
                    currentAdapters = detectedAdapters;
                    return [4 /*yield*/, storageUtil.get()];
                case 2:
                    storedWalletName = _a.sent();
                    if (storedWalletName) {
                        currentAdapter = currentAdapters.find(function (a) { return a.name === storedWalletName; }) || null;
                    }
                    notifyAdaptersChange();
                    return [2 /*return*/];
            }
        });
    }); })();
    // Subscribe to dynamic adapter changes
    (0, wallet_standard_base_1.subscribeToWalletAdapterChanges)(function (updatedAdapters) {
        var mergedAdapters = __spreadArray(__spreadArray([], adapters, true), updatedAdapters, true);
        var uniqueAdapters = mergedAdapters.filter(function (adapter, index, array) {
            return array.findIndex(function (a) { return a.name === adapter.name; }) === index;
        });
        currentAdapters = uniqueAdapters;
        notifyAdaptersChange();
    });
    return {
        /**
         * Get the current adapter
         */
        getAdapter: function () { return currentAdapter; },
        /**
         * Select an adapter by wallet name
         */
        selectWallet: function (walletName) {
            // If same wallet, do nothing
            if ((currentAdapter === null || currentAdapter === void 0 ? void 0 : currentAdapter.name) === walletName)
                return currentAdapter;
            // If we have a current adapter, disconnect it
            if (currentAdapter && currentAdapter.connected) {
                try {
                    currentAdapter.disconnect();
                }
                catch (error) {
                    console.error('Error disconnecting wallet:', error);
                }
            }
            // Select new adapter
            if (!walletName) {
                currentAdapter = null;
                storageUtil.set(null);
                return null;
            }
            var adapter = currentAdapters.find(function (a) { return a.name === walletName; }) || null;
            currentAdapter = adapter;
            // Store selected wallet
            if (adapter) {
                storageUtil.set(walletName);
            }
            else {
                storageUtil.set(null);
            }
            return adapter;
        },
        /**
         * Connect to the selected wallet
         */
        connect: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!currentAdapter) {
                            throw new errors_1.HermisError(errors_1.HERMIS_ERROR__WALLET_CONNECTION__NO_WALLET_SELECTED, {});
                        }
                        if (!!currentAdapter.connected) return [3 /*break*/, 2];
                        return [4 /*yield*/, currentAdapter.connect()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, currentAdapter];
                }
            });
        }); },
        /**
         * Disconnect from the current wallet
         */
        disconnect: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(currentAdapter === null || currentAdapter === void 0 ? void 0 : currentAdapter.connected)) return [3 /*break*/, 2];
                        return [4 /*yield*/, currentAdapter.disconnect()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        /**
         * Auto-connect to the stored wallet
         */
        autoConnect: function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!currentAdapter)
                            return [2 /*return*/, null];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, currentAdapter.autoConnect()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, currentAdapter];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Error auto-connecting wallet:', error_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        }); },
        /**
         * Sign a transaction (supports both legacy and Kit architectures)
         */
        signTransaction: function (transaction, options) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!currentAdapter) {
                            throw new errors_1.HermisError(errors_1.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED, { walletName: undefined });
                        }
                        return [4 /*yield*/, (0, solana_headless_core_1.signTransaction)(transaction, currentAdapter, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        /**
         * Sign multiple transactions (supports both legacy and Kit architectures)
         */
        signAllTransactions: function (transactions, options) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!currentAdapter) {
                            throw new errors_1.HermisError(errors_1.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED, { walletName: undefined });
                        }
                        return [4 /*yield*/, (0, solana_headless_core_1.signAllTransactions)(transactions, currentAdapter, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        /**
         * Send a transaction (supports both legacy and Kit architectures)
         */
        sendTransaction: function (connection, transaction, options) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!currentAdapter) {
                            throw new errors_1.HermisError(errors_1.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED, { walletName: undefined });
                        }
                        return [4 /*yield*/, (0, solana_headless_core_1.sendTransaction)(connection, transaction, currentAdapter, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        /**
         * Sign and send a transaction in one operation (supports both legacy and Kit architectures)
         */
        signAndSendTransaction: function (connection, transaction, options) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!currentAdapter) {
                            throw new errors_1.HermisError(errors_1.HERMIS_ERROR__WALLET_CONNECTION__NOT_CONNECTED, { walletName: undefined });
                        }
                        return [4 /*yield*/, (0, solana_headless_core_1.signAndSendTransaction)(connection, transaction, currentAdapter, options)];
                    case 1: 
                    // Delegate to core function which handles atomic signAndSendTransaction
                    // for wallets that support it, or falls back to sign-then-send
                    return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        /**
         * Get all available wallet adapters
         */
        getAdapters: function () { return __spreadArray([], currentAdapters, true); },
        /**
         * Subscribe to adapter list changes
         */
        onAdaptersChange: function (callback) {
            adaptersChangeCallbacks.add(callback);
            // Immediately call with current adapters if available
            if (currentAdapters.length > 0) {
                callback(__spreadArray([], currentAdapters, true));
            }
            // Return unsubscribe function
            return function () { return adaptersChangeCallbacks.delete(callback); };
        }
    };
}
/**
 * Class to manage wallet adapters with event emission
 */
var WalletAdapterManager = /** @class */ (function (_super) {
    __extends(WalletAdapterManager, _super);
    function WalletAdapterManager(adapters, localStorageKey) {
        if (adapters === void 0) { adapters = []; }
        if (localStorageKey === void 0) { localStorageKey = 'walletName'; }
        var _this = _super.call(this) || this;
        _this.adapters = [];
        _this.selectedAdapter = null;
        _this.cleanupListeners = null;
        _this.isHandlingError = false;
        // Initialize wallet detection and merge with provided adapters
        (0, wallet_standard_base_1.initializeWalletDetection)();
        var allAdapters = (0, wallet_standard_base_1.getDetectedWalletAdapters)(adapters);
        _this.adapters = allAdapters.filter(function (adapter) { return adapter.readyState !== index_1.WalletReadyState.Unsupported; });
        _this.storageUtil = (0, storage_1.createLocalStorageUtility)(localStorageKey, null);
        // Initialize from storage
        _this.storageUtil.get().then(function (storedWalletName) {
            if (storedWalletName) {
                _this.selectedAdapter = _this.adapters.find(function (a) { return a.name === storedWalletName; }) || null;
                // Set up event listeners if we have a stored adapter
                if (_this.selectedAdapter) {
                    _this.setupEventListeners();
                }
            }
        });
        return _this;
    }
    /**
     * Get all wallet adapters
     */
    WalletAdapterManager.prototype.getAdapters = function () {
        return this.adapters;
    };
    /**
     * Get the currently selected adapter
     */
    WalletAdapterManager.prototype.getSelectedAdapter = function () {
        return this.selectedAdapter;
    };
    /**
     * Select a wallet adapter by name
     */
    WalletAdapterManager.prototype.selectAdapter = function (walletName) {
        var _a;
        // If same wallet, do nothing
        if (((_a = this.selectedAdapter) === null || _a === void 0 ? void 0 : _a.name) === walletName)
            return this.selectedAdapter;
        // Clean up any existing listeners
        this.cleanupAdapterListeners();
        // If we have a current adapter, disconnect it
        if (this.selectedAdapter && this.selectedAdapter.connected) {
            try {
                this.selectedAdapter.disconnect();
            }
            catch (error) {
                console.error('Error disconnecting wallet:', error);
            }
        }
        // Select new adapter
        if (!walletName) {
            this.clearSelectedAdapter();
            return null;
        }
        var adapter = this.adapters.find(function (a) { return a.name === walletName; }) || null;
        this.selectedAdapter = adapter;
        // Set up event listeners for the new adapter
        if (adapter) {
            this.setupEventListeners();
            this.storageUtil.set(walletName);
        }
        else {
            this.storageUtil.set(null);
        }
        this.emit('adapterChange', adapter);
        return adapter;
    };
    WalletAdapterManager.prototype.cleanupAdapterListeners = function () {
        if (this.cleanupListeners) {
            this.cleanupListeners();
            this.cleanupListeners = null;
        }
    };
    WalletAdapterManager.prototype.clearSelectedAdapter = function () {
        this.selectedAdapter = null;
        this.storageUtil.set(null);
        this.emit('adapterChange', null);
    };
    WalletAdapterManager.prototype.emitSafeError = function (error) {
        var _this = this;
        // Prevent concurrent error handling
        if (this.isHandlingError)
            return;
        try {
            this.isHandlingError = true;
            this.emit('error', error);
        }
        finally {
            // Use setTimeout to prevent immediate re-triggering
            setTimeout(function () {
                _this.isHandlingError = false;
            }, 100);
        }
    };
    /**
     * Connect to the selected wallet
     */
    WalletAdapterManager.prototype.connect = function () {
        return __awaiter(this, void 0, Promise, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedAdapter) {
                            return [2 /*return*/, null];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!!this.selectedAdapter.connected) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.selectedAdapter.connect()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, this.selectedAdapter];
                    case 4:
                        error_2 = _a.sent();
                        this.emitSafeError(error_2);
                        return [2 /*return*/, null];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Disconnect from the current wallet
     */
    WalletAdapterManager.prototype.disconnect = function () {
        return __awaiter(this, void 0, Promise, function () {
            var error_3;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.selectedAdapter) === null || _a === void 0 ? void 0 : _a.connected)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.selectedAdapter.disconnect()];
                    case 2:
                        _b.sent();
                        this.clearSelectedAdapter();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _b.sent();
                        this.emitSafeError(error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Auto-connect to the stored wallet
     */
    WalletAdapterManager.prototype.autoConnect = function () {
        return __awaiter(this, void 0, Promise, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedAdapter)
                            return [2 /*return*/, null];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.selectedAdapter.autoConnect()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.selectedAdapter];
                    case 3:
                        error_4 = _a.sent();
                        this.emitSafeError(error_4);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Set up event listeners for the selected adapter
     * @private
     */
    WalletAdapterManager.prototype.setupEventListeners = function () {
        var _this = this;
        if (!this.selectedAdapter)
            return;
        this.cleanupListeners = (0, adapters_1.addWalletAdapterEventListeners)(this.selectedAdapter, {
            onConnect: function (publicKey) {
                _this.emit('connect', publicKey);
            },
            onDisconnect: function () {
                _this.emit('disconnect');
            },
            onError: function (error) {
                _this.emitSafeError(error);
            },
            onReadyStateChange: function (readyState) {
                _this.emit('readyStateChange', readyState);
            }
        });
    };
    /**
     *
     * @param optional wallet adapter event
     * @returns The class to manage wallet adapters with event emission
     */
    WalletAdapterManager.prototype.removeAllListeners = function (event) {
        _super.prototype.removeAllListeners.call(this, event);
        return this;
    };
    /**
     * Clean up resources when no longer needed
     */
    WalletAdapterManager.prototype.dispose = function () {
        if (this.cleanupListeners) {
            this.cleanupListeners();
            this.cleanupListeners = null;
        }
        this.removeAllListeners();
    };
    /**
     * Sign a transaction (supports both legacy and Kit architectures)
     * @param transaction - The transaction to sign (Transaction, VersionedTransaction, or TransactionMessage)
     * @param options - Optional dual architecture configuration
     * @returns The signed transaction or null if error occurs
     */
    WalletAdapterManager.prototype.signTransaction = function (transaction, options) {
        return __awaiter(this, void 0, Promise, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedAdapter) {
                            this.emitSafeError("No Adapter connected");
                            return [2 /*return*/, null];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, solana_headless_core_1.signTransaction)(transaction, this.selectedAdapter, options)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_5 = _a.sent();
                        this.emitSafeError(error_5);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign multiple transactions (supports both legacy and Kit architectures)
     * @param transactions - Array of transactions to sign (all same architecture)
     * @param options - Optional dual architecture configuration
     * @returns Array of signed transactions or null if error occurs
     */
    WalletAdapterManager.prototype.signAllTransaction = function (transactions, options) {
        return __awaiter(this, void 0, Promise, function () {
            var error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedAdapter) {
                            this.emitSafeError("No Adapter connected");
                            return [2 /*return*/, null];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, solana_headless_core_1.signAllTransactions)(transactions, this.selectedAdapter, options)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_6 = _a.sent();
                        this.emitSafeError(error_6);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign a message (supports both legacy and Kit architectures)
     * @param message - The message to sign (string or Uint8Array)
     * @param options - Optional dual architecture configuration
     * @returns The signature bytes or null if error occurs
     */
    WalletAdapterManager.prototype.signMessage = function (message, options) {
        return __awaiter(this, void 0, Promise, function () {
            var error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedAdapter) {
                            this.emitSafeError("No Adapter connected");
                            return [2 /*return*/, null];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, solana_headless_core_1.signMessage)(message, this.selectedAdapter, options)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_7 = _a.sent();
                        this.emitSafeError(error_7);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Send a transaction (supports both legacy and Kit architectures)
     * @param connection - The Solana connection (Legacy Connection or Kit Rpc)
     * @param transaction - The transaction to send
     * @param options - Optional dual architecture configuration
     * @returns The transaction signature or null if error occurs
     */
    WalletAdapterManager.prototype.sendTransaction = function (connection, transaction, options) {
        return __awaiter(this, void 0, Promise, function () {
            var error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedAdapter) {
                            this.emitSafeError("No Adapter connected");
                            return [2 /*return*/, null];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, solana_headless_core_1.sendTransaction)(connection, transaction, this.selectedAdapter, options)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_8 = _a.sent();
                        this.emitSafeError(error_8);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sign and send a transaction in one operation (supports both legacy and Kit architectures)
     * @param connection - The Solana connection (Legacy Connection or Kit Rpc)
     * @param transaction - The transaction to sign and send
     * @param options - Optional dual architecture configuration
     * @returns The transaction signature or null if error occurs
     */
    WalletAdapterManager.prototype.signAndSendTransaction = function (connection, transaction, options) {
        return __awaiter(this, void 0, Promise, function () {
            var error_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedAdapter) {
                            this.emitSafeError("No Adapter connected");
                            return [2 /*return*/, null];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, solana_headless_core_1.signAndSendTransaction)(connection, transaction, this.selectedAdapter, options)];
                    case 2: 
                    // Sign and send the transaction in one atomic operation
                    return [2 /*return*/, _a.sent()];
                    case 3:
                        error_9 = _a.sent();
                        this.emitSafeError(error_9);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return WalletAdapterManager;
}(index_1.EventEmitter));
exports.WalletAdapterManager = WalletAdapterManager;
